import React from 'react';
import PropTypes from 'prop-types';

const DownloadButton = ({ href, label, filename, style }) => (
  <div className="w-50 mt-3">
    <a download={filename} href={href} target="_blank" rel="noopener noreferrer" className={`btn btn-${style} link-unstyled`}>{label}</a>
  </div>
);

DownloadButton.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  filename: PropTypes.string,
  style: PropTypes.string,
};

DownloadButton.defaultProps = {
  filename: true,
  style: 'black',
};

export default DownloadButton;
